import { api, channelNames, listeners } from '@wix/promote-analytics-adapter'
import type { BusinessLogger, RegisterEventListener } from '@wix/thunderbolt-symbols'
import type { IConsentPolicy } from 'feature-consent-policy'
import { getDefaultChannels, getLoadedChannels } from './channels'
import type { ReporterProps } from './channels/types'
import type { LoadedScripts } from './tag-manager/types'

let register: RegisterEventListener

export const getRegister = (): RegisterEventListener => register

export const initChannels = (reporterProps: ReporterProps, loadedScripts: LoadedScripts) => {
	const channels = getLoadedChannels(reporterProps, loadedScripts)
	if (channels.length) {
		api.init(channels)
		initGoogleReporterEC()
	}
}

export const initListeners = (reporterProps: ReporterProps) => {
	;[register] = api.addListener([listeners[channelNames.WIX_DEVELOPERS_ANALYTICS]], reporterProps)
}

export const initDefaultChannels = (
	reporterProps: ReporterProps,
	businessLogger: BusinessLogger,
	consentPolicy: IConsentPolicy
) => {
	const defaultChannels = getDefaultChannels(reporterProps, businessLogger, consentPolicy)
	api.init(defaultChannels)
	initListeners(reporterProps)
}

export const trackEvent = (eventName: string, params = {}, options = {}) => {
	api.trackEvent(eventName, params, options)
}

export const trackEventToChannelsOnly = (eventName: string, params = {}, options = {}) => {
	api.trackEventToChannelsOnly(eventName, params, options)
}

export const trackEventToListenersOnly = (eventName: string, params = {}, options = {}) => {
	api.trackEventToListenersOnly(eventName, params, options)
}

export const trackEventToEssentialsOnly = (eventName: string, params = {}, options = {}) => {
	api.trackEventToEssentialsOnly(eventName, params, options)
}

function initGoogleReporterEC() {
	window && typeof window.ga === 'function' && window.ga('require', 'ec')
}
